export const modalOption = [
    { value: 'noreply@jotform.com', label: 'noreply@jotform.com' },
    { value: '+ Add email address', label: '+ Add email address' }
]

export const emailTypeModal = [
    { value: 'Please Select', label: 'Please Select' },
    { value: 'SMTP', label: 'SMTP' },
]


export const securityProtocolData = [
    { value: 'TLS', label: 'TLS' },
    { value: 'SSL', label: 'SSL' },
]


export const initialFormState = [
    { id: 1, name: 'advanceCustomizeSaveEmail', value: modalOption[0].value, typeError: '' },
    { id: 2, name: 'EmailType', value: emailTypeModal[0].value, typeError: '' },
    { id: 3, name: 'Address', title: 'آدرس ایمیل', placeholder: 'john@smith.com', value: '', error: 'آدرس ایمیل نا معتبر است', touched: false, type: 'email', typeError: '' },
    { id: 4, name: 'Host', title: 'نام Host', placeholder: 'smtp.smith.com', value: '', error: 'نام Host نامعتبر است', touched: false, type: 'text', typeError: '' },
    { id: 5, name: 'Port', title: 'Port', placeholder: '25', value: '', error: 'پورت نامعتبر است', touched: false, type: 'number', typeError: '' },
    { id: 6, name: 'UserName', title: 'نام کاربری', placeholder: 'john', value: '', error: 'نام کاربری نامعتبر است', touched: false, type: 'text', typeError: '' },
    { id: 7, name: 'Password', title: 'رمز عبور', placeholder: '#supersecretpassword', value: '', error: 'رمز عبور نامعتبر است', touched: false, type: 'password', typeError: '' },
    { id: 8, name: 'Security Protocol', value: securityProtocolData[0].value, typeError: '' }
];